"use client"

import { useEffect, useState } from "react"
import Script from "next/script"
import { getUmamiWebsiteId } from "@/lib/data/umami"

const UmamiScript = () => {
  const [websiteId, setWebsiteId] = useState<string | null>(null)

  useEffect(() => {
    const fetchAndSetWebsiteId = async () => {
      const cachedId = localStorage.getItem("umamiWebsiteId")
      if (cachedId) {
        setWebsiteId(cachedId)
        return
      }

      try {
        const data = await getUmamiWebsiteId()

        if (data && data.websiteId) {
          setWebsiteId(data.websiteId)
          localStorage.setItem("umamiWebsiteId", data.websiteId)
        } else if (data && data.error) {
          throw new Error(data.error)
        }
      } catch (error) {
        //console.error("Failed to fetch Umami website ID via Server Action:", error)
      }
    }

    fetchAndSetWebsiteId()
  }, [])

  if (!websiteId) {
    return null
  }

  return (
    <Script
      src="https://umami.incastbox.com/script.js"
      data-website-id={websiteId}
      strategy="afterInteractive"
    />
  )
}

export default UmamiScript